export default "__VITE_ASSET__bJ1xyZ3n__"